import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {getContentHeaders, postContentHeaders} from '../common/headers';
import {AuthHttp} from 'angular2-jwt';
import {Customer} from '../models/customer.model';
import {BaseService} from '../base/service.base';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CustomerService extends BaseService {
  private _customers$: BehaviorSubject<Customer[]>;
  private _dataStore: {
    customers: Customer[]
  };

  constructor(private _http: AuthHttp) {
    super();
    this._dataStore = {customers: []};
    this._customers$ = <BehaviorSubject<Customer[]>>new BehaviorSubject([]);
  }

  get customers$() {
    return this._customers$.asObservable();
  }

  public loadAll(filter: string = '') {
    this._http.get(`${this.baseApiUrl}/customers${filter}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      this._dataStore.customers = result;
      this._customers$.next(this._dataStore.customers);
    }, error => console.error('Could not load customers.'));
  }

  public load(id: any) {
    this._http.get(`${this.baseApiUrl}/customers/${id}`, {headers: getContentHeaders})
      .map(response => response.json()).subscribe(result => {
      let notFound = true;

      this._dataStore.customers.forEach((item, index) => {
        if (item._id === result._id) {
          this._dataStore.customers[index] = result;
          notFound = false;
        }
      });

      if (notFound) {
        this._dataStore.customers.push(result);
      }

      this._customers$.next(this._dataStore.customers);
    }, error => console.error('Could not load customer.'));
  }

  public create(customer: Customer): Observable<any> {
    const shareable = this._http.post(`${this.baseApiUrl}/customers`, JSON.stringify(customer), {headers: postContentHeaders})
      .map(response => response.json()).share();

    shareable.subscribe(result => {
      if (result.length > 0) {
        this._dataStore.customers.push(result[0]);
        this._customers$.next(this._dataStore.customers);
      }
    }, error => console.error('Could not create customer.'));

    return shareable;
  }

  public update(customer: Customer): Observable<any> {
    const shareable = this._http.put(`${this.baseApiUrl}/customers/${customer._id}`, JSON.stringify(customer),
      {headers: postContentHeaders}).map(response => response.json()).share();

    shareable.subscribe(result => {
      this._dataStore.customers.forEach((defi, i) => {
        if (defi._id === result._id) {
          this._dataStore.customers[i] = result;
        }
      });

      this._customers$.next(this._dataStore.customers);
    }, error => console.error('Could not update customer.'));

    return shareable;
  }

  public remove(customerId: string): Observable<any> {
    const shareable = this._http.delete(`${this.baseApiUrl}/customers/${customerId}`).share();

    shareable.subscribe(response => {
      this._dataStore.customers.forEach((t, i) => {
        if (t._id === customerId) {
          this._dataStore.customers.splice(i, 1);
        }
      });

      this._customers$.next(this._dataStore.customers);
    }, error => console.error('Could not delete customer.'));

    return shareable;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/customers.service.ts